

export const formatDate = (iso) => {
  if (!iso) return ''
  const [y, m, d] = iso.split('-')
  return `${d}.${m}.${y}`
}

export const formatRange = (start, end) => {
  const s = formatDate(start)
  const e = formatDate(end)
  if (s && e) return `${s} — ${e}`
  return s || e
}

export const formatSubmittedAt = (value) => {
  if (!value) return ''
  return formatDate(value.split(' ')[0])
}